// extracted by mini-css-extract-plugin
export var measureBox = "_b6-0";